export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'checkbox',
    width: 40,
    align: 'center',
    fixed: 'left',
    type: 'checkbox',
    visible: !that.disabled,
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    align: 'center',
    width: 80,
    showHeaderOverflow: true,
    showOverflow: true,
    slots: { default: 'opt' },
    visible: !that.disabled,
  },
  {
    title: that.$l('table_label_ncNo') || 'NC编号',
    field: 'ncNo',
    align: 'center',
    width: 100,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_fabricName') || '面料名称',
    headerAlign: 'center',
    align: 'left',
    minWidth: 180,
    showHeaderOverflow: true,
    slots: { default: 'fabric' },
  },
  {
    title: that.$l('table_label_fabricPosition') || '面料位置',
    field: 'v_fabricPosition',
    align: 'center',
    width: 100,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_fabricUnit') || '面料单位',
    field: 'v_fabricUnit',
    align: 'center',
    width: 80,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_fabricWidth') || '门幅',
    field: 'fabricWidth',
    align: 'center',
    width: 80,
    showHeaderOverflow: true,
    showOverflow: true,
    formatter: ({ row }) => {
      const { fabricWidth: value } = row
      return !value ? value : value.toLocaleString()
    },
  },
  {
    title: that.$l('table_label_fabricWeight') || '面料克重',
    field: 'fabricWeight',
    align: 'center',
    width: 110,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_qty') || '耗料',
    field: 'qty',
    align: 'center',
    width: 80,
    showHeaderOverflow: true,
    showOverflow: true,
    formatter: ({ row }) => {
      const { qty: value } = row
      return !value ? value : value.toLocaleString()
    },
  },
  {
    title: that.$l('table_label_unitPrice') || '单价',
    field: 'unitPrice',
    align: 'center',
    width: 80,
    showHeaderOverflow: true,
    showOverflow: true,
    formatter: ({ row }) => {
      const { unitPrice: value } = row
      return !value ? value : value.toLocaleString()
    },
  },
  {
    title: that.$l('table_label_subPrice') || '小计',
    field: 'subPrice',
    align: 'center',
    width: 80,
    showHeaderOverflow: true,
    showOverflow: true,
    formatter: ({ row }) => {
      const { subPrice: value } = row
      return that.format(value)
    },
  },
]
